function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    "data-inject-url": "https://edublink.html.devsblink.com/assets/images/animated-svg-icons/non-degree-programs.svg",
    className: "svgInject",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.0913 17.2855L23.2222 12.495C22.8949 11.9522 22.1054 11.9522 21.778 12.495L14.4032 24.7712C14.2684 24.9998 14.2492 25.2855 14.3551 25.5236L17.0412 31.6569C17.099 31.7998 17.1279 31.9522 17.099 32.1046L16.2036 38.095C16.1266 38.5998 16.5213 39.0474 17.0316 39.0474H22.4905H27.9494C28.4597 39.0474 28.8544 38.5998 28.7774 38.095L27.882 32.1236C27.8628 31.9712 27.882 31.8093 27.9398 31.676L30.6259 25.5427C30.7318 25.295 30.7126 25.0188 30.5778 24.7903L28.6426 21.5712",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "68, 70",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.252 31.9902H28.7487",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "13, 15",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 27.9713C24.2546 27.9713 25.6771 26.5642 25.6771 24.8284C25.6771 23.0927 24.2546 21.6855 22.4999 21.6855C20.7452 21.6855 19.3228 23.0927 19.3228 24.8284C19.3228 26.5642 20.7452 27.9713 22.4999 27.9713Z",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "20, 22",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.0947V18.1043",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "7, 9",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 7.84739C24.4247 7.84739 25.9851 6.30383 25.9851 4.39977C25.9851 2.4957 24.4247 0.952148 22.4999 0.952148C20.575 0.952148 19.0146 2.4957 19.0146 4.39977C19.0146 6.30383 20.575 7.84739 22.4999 7.84739Z",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "22, 24",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01611 4.39941H19.0148",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "14, 16",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98471 6.39941C4.10134 6.39941 5.00654 5.50398 5.00654 4.39941C5.00654 3.29484 4.10134 2.39941 2.98471 2.39941C1.86809 2.39941 0.962891 3.29484 0.962891 4.39941C0.962891 5.50398 1.86809 6.39941 2.98471 6.39941Z",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "13, 15",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19321 18.8184C9.30983 18.8184 10.215 17.9229 10.215 16.8184C10.215 15.7138 9.30983 14.8184 8.19321 14.8184C7.07659 14.8184 6.17139 15.7138 6.17139 16.8184C6.17139 17.9229 7.07659 18.8184 8.19321 18.8184Z",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "13, 15",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19336 15.0947C8.19336 9.18037 13.0265 4.39941 19.0053 4.39941",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "17, 19",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9841 4.39941H25.9854",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "14, 16",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0057 6.39941C43.1223 6.39941 44.0275 5.50398 44.0275 4.39941C44.0275 3.29484 43.1223 2.39941 42.0057 2.39941C40.8891 2.39941 39.9839 3.29484 39.9839 4.39941C39.9839 5.50398 40.8891 6.39941 42.0057 6.39941Z",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "13, 15",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7972 18.8184C37.9138 18.8184 38.819 17.9229 38.819 16.8184C38.819 15.7138 37.9138 14.8184 36.7972 14.8184C35.6806 14.8184 34.7754 15.7138 34.7754 16.8184C34.7754 17.9229 35.6806 18.8184 36.7972 18.8184Z",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "13, 15",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7973 15.0947C36.7973 9.18037 31.9642 4.39941 25.9854 4.39941",
    stroke: "#ee4a62",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "17, 19",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.333 19.7903C27.5776 19.7903 27.7759 19.5941 27.7759 19.3522C27.7759 19.1102 27.5776 18.9141 27.333 18.9141C27.0884 18.9141 26.8901 19.1102 26.8901 19.3522C26.8901 19.5941 27.0884 19.7903 27.333 19.7903Z",
    stroke: "#ee4a62",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory2);
export default __webpack_public_path__ + "static/media/category-2.61a628182c04175d719f66a45e27e5da.svg";
export { ForwardRef as ReactComponent };